class NavigationReponsive {
  constructor() {
    this.menuAnnual = document.querySelector('.wp-header__navigation-main--annual');
    this.menuSustainability = document.querySelector('.wp-header__navigation-main--sustainability');
    this.menuSub = document.querySelector('.wp-subnav');

    this.menuBurger = document.querySelector('.wp-header__burger-label');
    this.menuNavigation = document.querySelector('.wp-header__navigation');

    if(this.menuAnnual && this.menuSub){
      this.bindMenuSub('.wp-menu-a__link--level-annual');
    } else if(this.menuSustainability && this.menuSub){
      this.bindMenuSub('.wp-menu-a__link--level-sustainability');
    }

    if(this.menuBurger && this.menuNavigation){
      this.bindMenu();
    }
  }

  bindMenu(){
    this.menuBurger.addEventListener('click', (e) => {
      this.menuNavigation.classList.toggle('wp-header__navigation--active');
    });
  }

  bindMenuSub(menuClass){
    let cloneSub = this.menuSub.cloneNode(true);
    cloneSub.classList.remove('wp-subnav');
    cloneSub.classList.add('wp-subnav--responsive');
    document.querySelector(menuClass).insertAdjacentElement('beforeend', cloneSub);
    this.bindMenuLevels(document.querySelectorAll('.wp-subnav--responsive .wp-menu-a__item--has-children .wp-menu-a__link--level-0'));
  }

  bindMenuLevels(menuLevels){
    menuLevels.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        let itemParent = item.closest('.wp-menu-a__item--has-children').classList;
        if(itemParent.contains('wp-menu--active')){
          itemParent.remove('wp-menu--active');
        } else {
          let menuActive = document.querySelector('.wp-menu--active');
          if(menuActive){
            menuActive.classList.remove('wp-menu--active');
          }
          itemParent.toggle('wp-menu--active');
        }
      });
    });
  }
}

export default NavigationReponsive;
